import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import cx from '@/utils/cx';
import useStyle from './style';

const Accordion = ({
  title,
  iconSrc,
  transitionTime,
  children,
  tabIndex,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isWrapperOpen, setIsWrapperOpen] = useState(false);
  const classes = useStyle({ transitionTime });

  function handleToggle() {
    setIsOpen((wasOpen) => {
      if (wasOpen) {
        setTimeout(() => {
          setIsWrapperOpen(false);
        }, transitionTime);
      } else {
        setIsWrapperOpen(true);
      }
      return !wasOpen;
    });
  }

  function handleKeyboardToggle(e) {
    if (e.key === ' ') {
      handleToggle();
    }
  }

  return (
    <div
      className={cx(
        classes.collapsibleItem,
      )}
      {...rest}
    >
      <div
        onClick={handleToggle}
        role="button"
        tabIndex={tabIndex}
        aria-label={title}
        onKeyPress={handleKeyboardToggle}
        className={classes.summary}
      >
        { iconSrc !== '' && <Icon src={iconSrc} size={45} _margin_right="md" /> }
        <div className={classes.title}>
          {title}
        </div>
        <Icon
          src="https://passenger-pwa-cdn.snapp.ir/icons/chevron-right.svg"
          size={24}
          rotation={isOpen ? -90 : 90}
        />
      </div>
      <div className={cx(classes.detailsWrapper, { [classes.detailsWrapperOpen]: isWrapperOpen })}>
        <div
          className={cx(classes.detailsContent, { [classes.contentOpen]: isOpen })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  iconSrc: PropTypes.string,
  transitionTime: PropTypes.number,
  tabIndex: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Accordion.defaultProps = {
  iconSrc: '',
  tabIndex: 0,
  transitionTime: 300,
};

export default Accordion;
